import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO34 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-4.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO34
